<template>
  <canvas :data-image="image" :data-image-left="imageLeft" :data-image-top="imageTop" :id="id" :style="`position: absolute; top: ${top}; left: ${left}; width: ${width}; height: ${height}`"></canvas>
</template>

<script>
export default {
  name: 'Canvas',
  props: {
    id: String,
    image: String,
    top: String,
    left: String,
    height: String,
    width: String,
    imageLeft: String,
    imageTop: String
  }
}
</script>